import _ from 'lodash'
import styled, { withTheme } from 'styled-components'
import { useSWRConfig } from 'swr'
import React, { useContext, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
// import { useDispatch } from 'react-redux'
import {
  removeTagPhenomenon,
  tagPhenomenon,
} from '@futures-platform/connectors/tag-service-api'
import {
  getFpTags,
  getGroupTags,
} from '@futures-platform/connectors/tag-service-api'
import { useTags } from '@futures-platform/hooks'
// import Tag from '../components/Tag_sangre_ui'
import { requestTranslation } from '@futures-platform/i18n'
import { Tag } from '@futures-platform/ui'
// import Tag from '../components/Tag_sangre_ui'
import { fetcher } from '../../helpers/fetcher'
import { capitalizeFirstLetter } from '../../helpers/helpers'
import {
  getContentCardData,
  getNewsFeedData,
  getPhenomena,
  getPhenomenaStatistic,
  getPhenomenonNewsByPhenId,
} from '../../helpers/phenomenonFetcher'
import { scenarioAPIs } from '../../helpers/scenarioApis'
import { ACTIONS } from '../../store/Actions'
import { DataContext } from '../../store/GlobalState'
import GroupX from './GroupX.svg'
import Oval from './Oval.svg'

const ELEMENT_WIDTH = 280
const FP_TOPBAR_OFFSET = process.env.NODE_ENV === 'development' ? 0 : 112

export const PhenomenaTagSelector = ({
  gid,
  contentTargetId,
  activeTagList,
  lang,
  dispatch,
  mutateTagsScenarioData,
  toogleTaggingSelectorModal,
  // addTagHandler,
  // removeTagHandler,
  // contentType,
}) => {
  const [iconTaggingSection, seticonTaggingSection] = useState('expand_more')
  const [groupTags, setgroupTags] = React.useState(null)
  const [fpTags, setfpTags] = React.useState(null)
  const [fpTagsAdded, setfpTagsAdded] = useState([])
  const [groupTagsAdded, setgroupTagsAdded] = useState([])
  const {
    state: { scenario },
  } = useContext(DataContext)
  React.useEffect(() => {
    const tagListFetcher = async () => {
      const tagListRes = await Promise.all([getFpTags(), getGroupTags(gid)])
      setgroupTags(() => tagListRes[1])
      setfpTags(() => tagListRes[0])
    }
    if (gid || Number(gid) === 0) {
      tagListFetcher()
    }
  }, [gid])

  const handleChangeIconTagSection = () => {
    if (iconTaggingSection === 'expand_more')
      seticonTaggingSection(() => `expand_less`)
    else {
      seticonTaggingSection(() => `expand_more`)
    }
  }

  useEffect(() => {
    let fpTagsTemp = []
    let groupTagsTemp = []
    !!activeTagList?.length &&
      activeTagList.map((tagUri, index) => {
        const tagObj =
          _.find(
            !!fpTags && !!fpTags?.length && fpTags,
            ({ uri }) => uri === tagUri,
          ) ||
          _.find(
            !!groupTags && !!groupTags?.length && groupTags,
            ({ uri }) => uri === tagUri,
          )

        if (!tagObj) {
          return null
        }
        const label = _.isString(tagObj.label)
          ? tagObj.label
          : tagObj.label[lang]
        const tagUriSplit = tagUri?.split('/')
        const isFPTags = tagUriSplit[1] === 'theme' ? true : false
        if (!!isFPTags) {
          fpTagsTemp.push({ tagUri, label, isFPTags })
        } else groupTagsTemp.push({ tagUri, label, isFPTags })
      })

    setfpTagsAdded(() => fpTagsTemp)
    setgroupTagsAdded(() => groupTagsTemp)
  }, [activeTagList, fpTags, groupTags, lang])

  const checkTagStatus = (tag) => {
    let found = false

    if (!activeTagList || !activeTagList?.length) {
      return found
    }

    activeTagList.map((t) => {
      if (_.isEqual(t, tag.uri)) {
        found = true
      }
    })

    return found
  }
  const tagsAdded = React.useMemo(() => {
    return [...fpTagsAdded, ...groupTagsAdded].sort((a, b) => {
      return a.label.localeCompare(b.label)
    })
  }, [fpTagsAdded, groupTagsAdded])

  return (
    <Padding
      id="tag-selector-modal"
      style={{
        zIndex: 999999,
        // left: x - ELEMENT_WIDTH - 25 + window.scrollX + 'px',
        // // eslint-disable-next-line no-restricted-globals
        // top: y - FP_TOPBAR_OFFSET - 40 + window.scrollY + 'px',
        // left: '39%',
        // top:  FP_TOPBAR_OFFSET  + window.scrollY -200 + 'px',
        // top: '77px',

        padding: 0,
        position: 'relative',
        paddingLeft: '18px',
        paddingTop: '18px',
        background: 'transparent',
        // marginLeft: !!isInEditMode ? '15px' : 'unset'
      }}>
      <div>
        <img
          src={Oval}
          style={{
            zIndex: 999999998,
            height: '18px',
            width: '18px',
            position: 'absolute',
            top: '4%',
            left: '3.3%',
          }}
        />
        <span
          style={{
            zIndex: 999999999,
            height: '18px',
            width: '18px',
            position: 'absolute',
            top: '4.4%',
            left:
              !!activeTagList?.length && activeTagList?.length > 9
                ? '4.5%'
                : '5%',
            color: 'white',
            fontSize: '10px',
            fontWeight: 700,
          }}>
          {activeTagList?.length || 0}
        </span>
        <img
          onClick={toogleTaggingSelectorModal}
          src={GroupX}
          style={{
            zIndex: 999999998,
            height: '18px',
            width: '18px',
            position: 'absolute',
            top: '4%',
            right: '0',
            cursor: 'pointer',
          }}
        />
      </div>
      {/* <div id = 'tagging-selector-header' 
      style={{background: 'white', position:'unset', width:'100%', padding:'10px'}}>
        <p> Add/remove tags</p>
        <div id="tagging-selector-header-content" style={{marginTop: '12px'}}>You can now select
        the most suitable tags to the content.
        When done, please remember to SAVE your work!
        </div>

      </div> */}
      <ListContainer
        style={{
          boxShadow: `0 1px 1px rgba(0,0,0,0.11), 
        0 2px 2px rgba(0,0,0,0.11), 
        0 4px 4px rgba(0,0,0,0.11), 
        0 6px 8px rgba(0,0,0,0.11),
        0 8px 16px rgba(0,0,0,0.11)`,
        }}>
        {/* <div style={{width: `${ELEMENT_WIDTH + 40}px`}}> */}
        {/* {
          <Thumb 
            // style={{ left: x - 1088 + 'px', top: y - FP_TOPBAR_OFFSET + window.scrollY - 500 + 'px' }} 
              style={{ right: `-12px`, top:`42px` }} 

            />
        } */}
        {/* {loading && (<div className='pl-2'>{requestTranslation('loading')}</div>)}
        {error && (<div className='pl-2'>{requestTranslation('tagLoadingError')}</div>)} */}
        {(!!fpTags?.length || !!groupTags?.length) && (
          <div style={{ position: 'relative' }}>
            <Dropdown
              onClick={handleChangeIconTagSection}
              className="dropdown-toggle d-flex align-items-center justify-content-between"
              type="button"
              data-toggle="collapse"
              data-target="#tagging-selector-header"
              aria-expanded="true"
              style={{
                cursor: 'pointer',
                background: 'rgb(250, 250, 250)',
                padding: '10px',
                paddingBottom: 0,
              }}>
              <p
                style={{
                  fontSize: '11px',
                  color: 'rgb(102, 117, 133)',
                  textTransform: 'upper',
                  lineHeight: '20px',
                  fontWeight: 500,
                  fontFamily: 'L10',
                  margin: 0,
                }}>
                TAGS
              </p>
              <div>
                <i className="material-icons">{iconTaggingSection}</i>
              </div>
            </Dropdown>
            <div
              className="show"
              id="tagging-selector-header"
              onClick={handleChangeIconTagSection}
              // cursor: 'move',
              // position: !isInEditMode ? 'absolute' : 'unset',
              // background: !!isInEditMode ? 'white' : 'unset',
              // width: !!isInEditMode ? '100%': 'unset',
              // height: !!isInEditMode ? 'fit-content' : 'unset',
              // padding: !!isInEditMode ? '10px' : 'unset',
              // height: !!isInEditMode ? '-moz-max-content' : 'unset',    /* Firefox/Gecko */
              // height: !!isInEditMode ? '-webkit-max-content' : 'unset'/* Chrome */
              style={{
                background: '#fafafa',
                position: 'unset',
                width: '100%',
                padding: '10px',
                paddingTop: 0,
              }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  overflowX: 'clip',
                }}>
                {!!tagsAdded?.length &&
                  tagsAdded?.length <= 3 &&
                  tagsAdded?.map((tagAdded, index) => {
                    return (
                      <>
                        <p
                          style={{
                            fontSize: '14px',
                            color: '#080808',
                            lineHeight: '20px',
                            fontWeight: 700,
                            fontFamily: 'L10',
                            margin: 0,
                          }}>
                          {tagAdded?.label}
                        </p>
                        {tagsAdded?.length - 1 > index && (
                          <p
                            style={{
                              margin: 0,
                              marginRight: '3px',
                            }}>
                            ,
                          </p>
                        )}
                      </>
                    )
                  })}
                {!!tagsAdded?.length &&
                  tagsAdded?.length > 3 &&
                  tagsAdded?.slice(0, 3).map((tagAdded, index) => {
                    return (
                      <>
                        <p
                          style={{
                            fontSize: '14px',
                            color: '#080808',
                            lineHeight: '20px',
                            fontWeight: 700,
                            fontFamily: 'L10',
                            margin: 0,
                          }}>
                          {tagAdded?.label}
                        </p>
                        {tagsAdded?.length - 1 > index && (
                          <p
                            style={{
                              margin: 0,
                              marginRight: '3px',
                            }}>
                            ,
                          </p>
                        )}
                      </>
                    )
                  })}
                {!!tagsAdded?.length && tagsAdded?.length > 3 && <>{' ...'}</>}
              </div>
            </div>
            {!!groupTags?.length && (
              <TagLabel
                style={{
                  color: 'rgb(102, 117, 133)',
                }}
                className="mb-0 ml-2 mt-4">
                Group tags
              </TagLabel>
            )}
            <div className={`d-flex flex-wrap flex-row`}>
              {!!groupTags?.length
                ? groupTags
                    ?.sort(function (a, b) {
                      const textA = !!a?.label[lang]
                        ? a?.label[lang].toUpperCase()
                        : a?.label?.toUpperCase()
                      const textB = !!b?.label[lang]
                        ? b?.label[lang].toUpperCase()
                        : b?.label?.toUpperCase()
                      return textA < textB ? -1 : textA > textB ? 1 : 0
                    })
                    ?.map((tag, index) => {
                      const isActive = checkTagStatus(tag)

                      return (
                        <OptionsListItem key={index}>
                          <Tag
                            isFPTags={false}
                            isNotFilter={true}
                            label={
                              tag.label[lang]
                                ? capitalizeFirstLetter(tag.label[lang])
                                : capitalizeFirstLetter(tag.label)
                            }
                            active={isActive}
                            onClick={async () => {
                              try {
                                if (!isActive) {
                                  dispatch({
                                    type: ACTIONS.TAGS,
                                    payload: [...activeTagList, tag?.uri],
                                  })
                                  // await fetcher.tagScenarioCard(
                                  //   gid,
                                  //   contentTargetId,
                                  //   tag?.uri,
                                  // )
                                } else {
                                  const tagSelectorListRm =
                                    activeTagList?.filter((t) => {
                                      return t !== tag?.uri
                                    })
                                  dispatch({
                                    type: ACTIONS.TAGS,
                                    payload: [...tagSelectorListRm],
                                  })
                                  // await fetcher.removeTagScenarioCard(
                                  //   gid,
                                  //   contentTargetId,
                                  //   tag?.uri,
                                  // )
                                }
                                // await mutateTagsScenarioData()
                              } catch (error) {
                                console.error(error)
                              }
                            }}
                          />
                        </OptionsListItem>
                      )
                    })
                : null}
            </div>
            <TagLabel
              style={{
                color: 'rgb(102, 117, 133)',
              }}
              className="mb-0 mt-2 ml-2 mt-4">
              FP tags
            </TagLabel>
            <div className="d-flex flex-wrap flex-row mb-4">
              {!!fpTags?.length &&
                fpTags
                  ?.sort(function (a, b) {
                    const textA = !!a?.label[lang]
                      ? a?.label[lang].toUpperCase()
                      : a?.label?.toUpperCase()
                    const textB = !!b?.label[lang]
                      ? b?.label[lang].toUpperCase()
                      : b?.label?.toUpperCase()
                    return textA < textB ? -1 : textA > textB ? 1 : 0
                  })
                  ?.map((tag, index) => {
                    const isActive = checkTagStatus(tag)

                    return (
                      <OptionsListItem key={index}>
                        <Tag
                          label={
                            tag.label[lang]
                              ? capitalizeFirstLetter(tag.label[lang])
                              : capitalizeFirstLetter(tag.label)
                          }
                          isFPTags={true}
                          isNotFilter={true}
                          active={isActive}
                          onClick={async () => {
                            try {
                              if (!isActive) {
                                dispatch({
                                  type: ACTIONS.TAGS,
                                  payload: [...activeTagList, tag?.uri],
                                })
                                // await fetcher.tagScenarioCard(
                                //   gid,
                                //   contentTargetId,
                                //   tag?.uri,
                                // )
                              } else {
                                const tagSelectorListRm = activeTagList?.filter(
                                  (t) => {
                                    return t !== tag?.uri
                                  },
                                )
                                dispatch({
                                  type: ACTIONS.TAGS,
                                  payload: [...tagSelectorListRm],
                                })
                                // await fetcher.removeTagScenarioCard(
                                //   gid,
                                //   contentTargetId,
                                //   tag?.uri,
                                // )
                              }

                              // await mutateTagsScenarioData()
                            } catch (error) {
                              console.error(error)
                            }
                          }}
                        />
                      </OptionsListItem>
                    )
                  })}
            </div>
          </div>
        )}
        {/* </div> */}
      </ListContainer>
    </Padding>
  )
}

const ListContainer = styled.div`
  overflow: auto;
  resize: both;
  min-height: 50px;
  min-width: 50px;
  width: ${ELEMENT_WIDTH}px;
  height: 280px;
  max-width: 700px;
  max-height: 700px;
  ::-webkit-scrollbar {
    width: 16px;
  }

  // ::-webkit-resize {
  //   width: 52px;
  // }
  ::-webkit-scrollbar-thumb {
    background: #ececec;
    border-radius: 20px;
  }

  ::-webkit-scrollbar-track {
    background: white;
    border-radius: 20px;
  }
`

const Thumb = styled.div`
  // background: #F6F4F7;
  background: linear-gradient(to top right, transparent 50%, #f6f4f7 50%);
  width: 25px;
  height: 25px;
  transform: rotate(45deg);
  /*box-shadow: 0 1px 2px 0 rgba(0,0,0,0.05), 0 1px 3px 0 rgba(0,0,0,0.05);*/
  position: absolute;
  z-index: 9;
`

const Padding = styled.div`
  /*box-shadow: 0 1px 2px 0 rgba(0,0,0,0.05), 0 1px 3px 0 rgba(0,0,0,0.05);*/
  padding: 15px 8px;
  position: absolute;
  background: #f6f4f7;
  border-radius: 2px;
  z-index: 10;
`

const TagLabel = styled.div`
  font-size: 12px;
  color: #667585;
`

const OptionsListItem = styled.div`
  padding: 0 5px;
  display: flex;
  align-items: center;
  margin-top: 8px;
`
const Dropdown = styled.div`
  -webkit-appearance: none;
  &:after {
    display: none;
  }
`
